import { initPublicHeader } from './header';

function initProductFilter() {
    const categoryCards = document.querySelectorAll('.category-card');
    const productItems = document.querySelectorAll('.product-item');
    const productsRange = document.getElementById('products-range');
    const productsTotal = document.getElementById('products-total');
    const productsContainer = document.getElementById('products-container');
    const noProductsMessage = productsContainer?.dataset.noProductsMessage || '';
    const totalProducts = productItems.length;

    if (!categoryCards.length || !productsContainer) {
        return;
    }

    if (productsTotal) {
        productsTotal.textContent = String(totalProducts);
    }

    const defaultCategory = document.querySelector('.category-card[data-category="all"]');
    defaultCategory?.classList.add('active');

    function filterProducts(categorySlug) {
        let visibleCount = 0;

        productItems.forEach(item => {
            const rawCategories = item.getAttribute('data-categories') || '';
            const itemCategories = rawCategories.split(',').map(category => category.trim()).filter(Boolean);
            const shouldShow = categorySlug === 'all' || itemCategories.includes(categorySlug);

            item.classList.toggle('d-none', !shouldShow);

            if (shouldShow) {
                visibleCount++;
            }
        });

        if (productsRange) {
            productsRange.textContent = visibleCount === 0 ? '0' : `1-${visibleCount}`;
        }

        let messageElement = document.getElementById('no-products-message');

        if (visibleCount === 0) {
            if (!messageElement) {
                messageElement = document.createElement('div');
                messageElement.id = 'no-products-message';
                messageElement.className = 'text-center py-5 col-12';

                const message = document.createElement('p');
                message.className = 'text-muted';
                message.textContent = noProductsMessage;

                messageElement.appendChild(message);
                productsContainer.appendChild(messageElement);
            } else {
                messageElement.classList.remove('d-none');
            }
        } else {
            messageElement?.classList.add('d-none');
        }
    }

    categoryCards.forEach(card => {
        card.addEventListener('click', function () {
            const selectedCategory = this.getAttribute('data-category') || 'all';

            categoryCards.forEach(categoryCard => categoryCard.classList.remove('active'));
            this.classList.add('active');
            filterProducts(selectedCategory);
        });
    });

    filterProducts('all');
}

document.addEventListener('DOMContentLoaded', function () {
    initPublicHeader();
    initProductFilter();
});